import React, { useState, useEffect } from "react";
import { ModalPadrao, InputNumberPadrao, BtnPadrao, LabelPadrao, LoadingContainerPadrao, SemDados } from "../../components/Base";
import { Divider, Result, Tooltip, Collapse } from "antd";
import * as api from "./api";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import { FileExcelOutlined, MailOutlined, FileOutlined } from "@ant-design/icons";
import { toXML } from "jstoxml";
import ExcelFile from "react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelColumn from "react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import ExcelSheet from "react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import { Switch } from "@material-ui/core";
import TabelaGerarPedido from "./TabelaGerarPedido";
import { InputPadrao } from './../../components/Base';
import Mensagens from './../../components/Mensagens';
const INITIAL_MOV = { modelo: "estmax", AbaterEstoque: true, DiasVendas: 30, DiasEntrega: 0 };
const INITIAL_MIN = { modelo: "estmin", AbaterEstoque: false, DiasVendas: 0, DiasEntrega: 0 };
const { Panel } = Collapse;

function GerarPedido({ visible, onCancel, dados, id, dtIni, dtFim, fetch, ...props }) {
  const [filtros, setFiltros] = useState(INITIAL_MOV);

  const [detalhe, listarDados, loading] = useFetch(() => api.save(fetch, { produtos: dados, IdLoja: id, dtIni, dtFim, DiasMov: filtros.DiasEntrega + filtros.DiasVendas, ...filtros }));

  useEffect(() => {
    filtros.modelo === "estmax" ? setFiltros({ ...INITIAL_MOV, DiasVendas: dtFim.diff(dtIni, 'days') + 1 }) : setFiltros(INITIAL_MIN);
  }, [filtros.modelo]);

  function styleSpan(modelo) {
    return filtros.modelo === modelo ? "span-selected span-marked" : "span-selected";
  }

  const preGerarPedido = () => {
    if (filtros.modelo === "estmax" && filtros.DiasEntrega <= 0) {
      Mensagens.showWarning('Dias de entrega inválido');
      return;
    }

    listarDados();
  }

  return (
    <ModalPadrao
      width={window.innerWidth > 1100 ? 1100 : "95%"}
      onCancel={onCancel}
      title="Gerar Pedido"
      visible={visible}
      footer={
        <>
          {!detalhe && (<BtnPadrao type="primary" onClick={preGerarPedido}>Gerar Pedido</BtnPadrao>)}
          <BtnPadrao type="primary" onClick={onCancel} ghost>Sair</BtnPadrao>
        </>
      }
    >
      {!detalhe ? (
        <LoadingContainerPadrao loading={loading}>
          <h2 style={{ textAlign: "center" }}>Cálculo do Pedido</h2>
          <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <span style={{ marginRight: 10 }} onClick={() => setFiltros({ ...filtros, modelo: "estmax" })} className={styleSpan("estmax")}>
              Pela Movimentação
            </span>
            <span onClick={() => setFiltros({ ...filtros, modelo: "estmin" })} className={styleSpan("estmin")}>
              Pelo Estoque Mínimo
            </span>
          </div>
          {filtros.modelo === "estmax" && (
            <>
              <Divider style={{ margin: 0 }} />
              <div style={{ display: "flex", justifyContent: "space-between", padding: 10 }}>
                <LabelPadrao style={{ marginTop: 5 }}>Quantidade de dias de vendas</LabelPadrao>
                <InputNumberPadrao min={0} value={filtros.DiasVendas} onChange={v => setFiltros({ ...filtros, DiasVendas: v })} />
              </div>
              <Divider style={{ margin: 0 }} />
              <div style={{ display: "flex", justifyContent: "space-between", padding: 10 }}>
                <LabelPadrao style={{ marginTop: 5 }}>Quantidade de dias de entrega</LabelPadrao>
                <InputNumberPadrao min={0} value={filtros.DiasEntrega} onChange={v => setFiltros({ ...filtros, DiasEntrega: v })} />
              </div>
              <Divider style={{ margin: 0 }} />
              <div style={{ display: "flex", justifyContent: "space-between", padding: 10 }}>
                <LabelPadrao style={{ marginTop: 5 }}>Total de dias</LabelPadrao>
                <InputNumberPadrao value={filtros.DiasEntrega + filtros.DiasVendas} disabled />
              </div>
              <Divider style={{ margin: 0 }} />
              <div style={{ display: "flex", justifyContent: "space-between", padding: 10 }}>
                <LabelPadrao style={{ marginTop: 5 }}>Abater estoque atual</LabelPadrao>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Switch color="primary" checked={filtros.AbaterEstoque} onClick={() => setFiltros({ ...filtros, AbaterEstoque: !filtros.AbaterEstoque })} />
                  <span style={{ fontWeight: "bold" }}>{filtros.AbaterEstoque ? "SIM" : "NÃO"}</span>
                </div>
              </div>
            </>
          )}
          {/* <pre>{JSON.stringify({ produtos: dados, IdLoja: id, DiasMov: filtros.DiasEntrega + filtros.DiasVendas, ...filtros }, null, 2)}</pre> */}
        </LoadingContainerPadrao>
      ) : (
        <PedidoDetalhe detalhe={detalhe} fetch={fetch} />
      )}
    </ModalPadrao>
  );
}

export default GerarPedido;

function PedidoDetalhe({ detalhe, fetch }) {
  const [dados, setDados] = useState(detalhe.produtos);
  const [showDetalhe, setShowDetalhe] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState(undefined);
  const [sendEmail, sendingEmail] = useSave();

  useEffect(() => {
    if (showEmail) {
      console.log('email buscar');
      fetch().get("/analisereposicao/getemails/" + detalhe.idLoja)
        .then(response => {
          setEmail(response.data);
        })
    }
  }, [showEmail])

  const send = () => {
    //const xml = GerarXml(dados);

    sendEmail(() => api.sendEmail(fetch, { idLoja: detalhe.idLoja, dtIni: detalhe.dtIni, dtFim: detalhe.dtFim, dados: { ...detalhe, produtos: dados }, email }), () => Mensagens.showSucesso('Email enviado com sucesso!'))
  }

  return (
    <Result
      status="success"
      title={"Pedido gerado com sucesso! " + (!!detalhe ? detalhe.numero : '')}
      extra={
        <>
          <div style={{ display: "flex", justifyContent: "space-around", maxWidth: 300, margin: "auto" }}>
            <PedidoXml dados={dados} />
            <PedidoExcel dados={dados} />
            {/* <Tooltip title="Enviar por Email" onClick={send} disabled={sendingEmail}>
              <MailOutlined className="icon-styled" style={{ fontSize: 60 }} />
            </Tooltip> */}
            <Tooltip title="Enviar por Email" onClick={() => setShowEmail(!showEmail)}>
              <MailOutlined className="icon-styled" style={{ fontSize: 60 }} />
            </Tooltip>
          </div>
          {showEmail && <div style={{ marginTop: 10, marginBottom: 20, textAlign: 'center' }}><InputPadrao placeholder="Email alternativo" style={{ maxWidth: 400 }} value={email} onChange={e => setEmail(e.target.value)} /> <BtnPadrao type="link" onClick={send} loading={sendingEmail} disabled={!email}>Enviar</BtnPadrao></div>}
          <Collapse onChange={() => setShowDetalhe(!showDetalhe)} expandIcon={false} ghost>
            <Panel header={showDetalhe ? <p>Ocultar detalhes do pedido</p> : <p>Ver detalhes do pedido</p>} key="1">
              {showDetalhe && <> {(dados || []).length ? <TabelaGerarPedido dados={dados} setDados={setDados} /> : <SemDados />}</>}
            </Panel>
          </Collapse>
        </>
      }
    />
  );
}

function PedidoExcel({ dados, ...props }) {
  return (
    <ExcelFile
      element={
        <Tooltip title="Exportar para Excel">
          <FileExcelOutlined className="icon-styled" style={{ fontSize: 60 }} />
        </Tooltip>
      }
    >
      <ExcelSheet data={dados} name="Analise">
        <ExcelColumn label="Fabricante" value="fabricante" />
        <ExcelColumn label="Cod EAN" value="ean" />
        <ExcelColumn label="Ref" value="codigo" />
        <ExcelColumn label="Produto" value="nome" />
        <ExcelColumn label="Quantidade" value="qtdPedido" />
        {/* <ExcelColumn label="UN" value="un" /> */}
        {/* <ExcelColumn label="EMBALAGEM" value="embalagem" /> */}
        {/* <ExcelColumn label="SUGESTÃO" value="sugestao" /> */}
        <ExcelColumn label="Valor Unitario" value="" />
        <ExcelColumn label="Nr. Pedido" value="pedido" />
      </ExcelSheet>
    </ExcelFile>
  );
}

function GerarXml(dados) {
  let pedidos = { pedidos: dados.map(x => { return { pedido: x } }) };
  return toXML(pedidos);
}

function PedidoXml({ dados }) {
  const downloadTxtFile = () => {
    const element = document.createElement("a");
    const xml = GerarXml(dados);
    const file = new Blob([xml], { type: "text/xml" });
    // console.log('dados xml', xml);
    element.href = URL.createObjectURL(file);
    element.download = "pedido";
    document.body.appendChild(element);
    element.click();
  };

  return (
    <Tooltip title="Arquivo XML">
      <FileOutlined onClick={downloadTxtFile} className="icon-styled" style={{ fontSize: 60 }} />
    </Tooltip>
  );
}
